import { useEffect } from 'react';
import type { IFramework } from '../../framework';

/** Esc 取消当前选中图层 */
export function useEscapeDeselectHotkey(framework: IFramework) {
    useEffect(() => {
        const escapeLayerActiveListener = framework.service.hotkey.onEsc(() => {
            if (framework.service.editor.isBaseOperate) return;
            framework.service.frame.delActiveLayer();
        });
        return () => {
            framework.service.events.off(escapeLayerActiveListener);
        };
    }, []);
}
